<template>
  <div class="businessWrap" id="page7">
    <h2>涿溪防窜货全力提升企业开源节流能力</h2>
    <div class="busMain">
      <div class="leftWrap">
        <div class="imgWrap">
          <transition name="busImg">
            <img class="busImg" v-show="busShow" src="../assets/images/hb.png" />
          </transition>
          <transition name="busImg">
            <img class="busImg" v-show="busShow" src="../assets/images/lmc.png" />
          </transition>
          <transition name="busImg">
            <img class="busImg" v-show="busShow" src="../assets/images/mp.png" />
          </transition>
          <transition name="busImg">
            <img class="busImg" v-show="busShow" src="../assets/images/wl.png" />
          </transition>
        </div>
        <div class="msg1">一物一码，让产品流向有据可查</div>
      </div>
      <div class="rightWrap">
        <div class="imgWrap">
          <transition name="numberImg1">
            <img class="numberImg1" v-show="busShow" src="../assets/images/88.png" />
          </transition>
          <transition name="numberImg2">
            <img class="numberImg2" v-show="busShow" src="../assets/images/xxx.png" />
          </transition>
          <transition name="numberImg3">
            <img class="numberImg3" v-show="busShow" src="../assets/images/x.png" />
          </transition>
        </div>
        <div class="msg2">让数据更可视化，实现产品的全生命周期管理</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'codeBusiness',
  data () {
    return {

    }
  },
  props:{
    busShow: Boolean,
  },
  methods:{

  }
}
</script>
<style scoped lang="scss">
/**一物一码动画**/
// .busImg{
//   animation: bus-in-out 1s .1s infinite
// }
.busImg-enter-active {
  animation: bus-in-out 1s;
  animation-delay: .3s;
}
.busImg-leave-active {
  animation: bus-in-out .3s reverse;
  animation-delay: 0;
}
@keyframes bus-in-out {
  0% {
    opacity: 0.2;
    transform: scale(0.2);
  }
  60% {
    opacity: 0.5;
    transform: scale(1.2);
  }
  100%{
    opacity: 1;
    transform: scale(1);
  }
}
/**全周期动画**/
// .numberImg1{
//   animation: numberImg1-in-out 1s .1s infinite
// }

.numberImg1-enter-active {
  animation: numberImg1-in-out 1s;
  animation-delay: .2s;
}
.numberImg1-leave-active {
  animation: numberImg1-in-out .3s reverse;
  animation-delay: 0;
}

@keyframes numberImg1-in-out {
  0% {
    transform: translateY(0px)
  }

  40%{
    transform: translateY(-10px)
  }

  80%{
    transform: translateY(10px)
  }
  100%{
    transform: translateY(0px)
  }
}

// .numberImg2{
//   animation: numberImg2-in-out 1s .1s infinite
// }
.numberImg2-enter-active {
  animation: numberImg2-in-out .8s;
  animation-delay: .1s;
}
.numberImg2-leave-active {
  animation: numberImg2-in-out .3s reverse;
  animation-delay: 0;
}
@keyframes numberImg2-in-out {
  0% {
    transform: translateY(0px)
  }

  40%{
    transform: translateY(10px)
  }

  80%{
    transform: translateY(-10px)
  }
  100%{
    transform: translateY(0px)
  }
}

// .numberImg3{
//   animation: numberImg1-in-out 1s .1s infinite
// }
.numberImg3-enter-active {
  animation: numberImg1-in-out .8s;
  animation-delay: .1s;
}
.numberImg3-leave-active {
  animation: numberImg1-in-out .3s reverse;
  animation-delay: 0;
}


.businessWrap{
  padding: 54px 100px 58px;
  background: #F7F6FA;
  > h2 {
    text-align: center;
    font-size: 40px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #1F2329;
    line-height: 56px;
    margin: 0;
    padding-bottom: 128px;
  }
  .busMain{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    font-size: 24px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #1F2329;
    line-height: 40px;
    text-align: center;
    .leftWrap{
      .imgWrap{
        width: 471px;
        background: url('../assets/images/bg_6.png') top left no-repeat;
        height: 258px;
        position: relative;
        margin-bottom: 40px;
        img:nth-child(1) {
          position: absolute;
          top: 69px;
          left: -22px;
        }
        img:nth-child(2) {
          position: absolute;
          top: 100px;
          left: 77px;
        }
        img:nth-child(3) {
          position: absolute;
          top: 130px;
          left: -56px;
        }
        img:nth-child(4) {
          position: absolute;
          top: 173px;
          left: 43px;
        }
      }
      .msg1{
        width: 80%;
        text-align: center;
        margin: 0 auto;
      }
    }
    .rightWrap{
      .imgWrap{
        width: 435px;
        background: url('../assets/images/bg_7.png') top left no-repeat;
        height: 258px;
        margin-bottom: 40px;
        position: relative;
        img:nth-child(1) {
          position: absolute;
          top: 122px;
          left: 127px;
        }
        img:nth-child(2) {
          position: absolute;
          top: 125px;
          left: 187px;
        }
        img:nth-child(3) {
          position: absolute;
          top: 119px;
          left: 261px;
        }
      }
      .msg2{
        width: 80%;
        text-align: center;
        margin: 0 auto;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CodeBusiness.vue